import React, { useState, useMemo } from 'react'
import clsx from 'clsx'
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  DialogActions,
  Dialog,
  DialogContent,
} from '@material-ui/core'
import { SVG } from 'components'
import { useFormContext } from 'react-hook-form'

import MenuContent from './MenuContent'

import { useTranslation } from 'react-i18next'
import useCookieBanner from 'hooks/useCookieBanner'

import constants from 'constants/index'
import helpers from 'helpers'
import styles from './styles'

const SecondLevelBanner = ({
  handleCloseSecondLevel,
  openSecondLevel,
  menuItemId,
}) => {
  const { t } = useTranslation()
  const { getBannerTextOverride, banner } = useCookieBanner()
  const { watch } = useFormContext()
  const selectedFile = watch('logo')
  const primaryColor = helpers.palette.validateColor(watch('primaryColor'))
  const { COOKIE_MENU_ITEMS_OBJECT, MENU_ITEMS_IDS } =
    constants.cookies.bannerTextOverride
  const [selectedItem, setSelectedItem] = useState(
    menuItemId || MENU_ITEMS_IDS.COOKIES_MENU_ITEM_ID,
  )
  const classes = styles()()

  const overrides = helpers.cookies.bannerTextOverride.getBannerLevel2Overrides(
    getBannerTextOverride,
  )

  const previewTexts = {
    title: overrides?.title || t('banner.secondLevelTitle'),
    confirm: overrides?.buttons?.confirm || t('button.confirmChoices'),
    reject: overrides?.buttons?.reject || t('button.rejectAllExceptNecessary'),
    accept: overrides?.buttons?.accept || t('button.acceptAllCookies'),
  }

  const availableMenuItems = COOKIE_MENU_ITEMS_OBJECT.filter((item) => {
    if (item.id === MENU_ITEMS_IDS.SERVICE_CHANNEL_MENU_ITEM_ID) {
      return banner?.privacyPortalEnabled
    }
    return true
  })

  const handleItemClick = (itemId) => setSelectedItem(itemId)

  return (
    <Dialog
      open={openSecondLevel}
      onClose={handleCloseSecondLevel}
      maxWidth="lg"
      fullWidth
    >
      <Grid container>
        <Grid item xs={12} md={3}>
          <Box paddingX={3} paddingY={2} className={classes.logoContainer}>
            {selectedFile || banner?.logo?.url ? (
              <img
                src={
                  selectedFile
                    ? URL.createObjectURL(selectedFile)
                    : banner?.logo?.url
                }
                alt="Logotipo"
                height={70}
                style={{ objectFit: 'contain', maxWidth: '100%' }}
              />
            ) : (
              <SVG.DPOEasy />
            )}
          </Box>
        </Grid>
        <Grid item md={9} xs={12}>
          <Box paddingX={3} paddingY={2} className={classes.titleContainer}>
            <Typography variant="h2" className={classes.title}>
              {previewTexts.title}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12} md={3}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              style={{ backgroundColor: primaryColor }}
            >
              {availableMenuItems.map((item) => {
                return (
                  <Button
                    fullWidth
                    key={item.id}
                    onClick={() => handleItemClick(item.id)}
                    className={clsx(
                      classes.menuButton,
                      selectedItem === item.id && classes.menuButtonActive,
                    )}
                  >
                    {t(item.translateKey)}
                  </Button>
                )
              })}
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Box height="60vh" style={{ padding: '36px 40px' }} overflow="auto">
              <MenuContent selectedItem={selectedItem} />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Grid item xs={12} lg={9}>
          <Box className={classes.actionsBox}>
            <Button variant="text" fullWidth className={classes.rejectButton}>
              {previewTexts.reject}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              className={classes.confirmButton}
            >
              {previewTexts.confirm}
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className={classes.acceptButton}
            >
              {previewTexts.accept}
            </Button>
          </Box>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

SecondLevelBanner.propTypes = {}

export default SecondLevelBanner
